import { render, staticRenderFns } from "./SystemAssetGoods.vue?vue&type=template&id=4a5b7334&scoped=true&"
import script from "./SystemAssetGoods.vue?vue&type=script&lang=js&"
export * from "./SystemAssetGoods.vue?vue&type=script&lang=js&"
import style0 from "./SystemAssetGoods.vue?vue&type=style&index=0&id=4a5b7334&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a5b7334",
  null
  
)

export default component.exports